import projectsService from '../services/projectsService';
import buildsService from '../services/buildsService';
import dataModel from '../models/DataModel';
import _ from 'lodash';

import OfflineQueue from './queue/OfflineQueue';
import DAO from './DAO.js';
import Metadata from '../helpers/metadata/Metadata';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import ReduxConstants, { RecordStates } from '../constants/ReduxConstants.js';

const user_complete = {
  additionalFields: ['profile_image'], role: { }, companies: { }, company_vendor_users: { vendor_user: { additionalFields: ['profile_image'], role: { }, companies: { } } }, 
};

const user_partial = {
  additionalFields: ['profile_image'], role: { }, companies: { }, 
};

export const project_root = {
  project: {
    builds: {
      user_build_assignments: { user: user_partial },
      build_owners: { companies: {} },
    },
    project_manager: {},
    project_users: { user: user_partial },
    location: { market: {}, location_users: { user: {} } },
    all_locations: { market: {}, location_users: { user: {} } },
    users: user_complete,
    company: {},
    unique_documents: {},
    reference_documents: {},
    custom_project_settings: {},
  },
};

export const project_build_root = {
  project: {
    builds: {
      user_build_assignments: { user: user_partial },
      build_owners: { additionalFields: ['profile_image'], companies: {} },
      tasks: {
        project: {},
        user_task_assignments: {
          user: user_partial,
        },
      },
    },
    project_manager: user_partial,
    project_users: { user: user_partial },
    location: { market: {} },
    all_locations: { market: {} },
    users: user_complete,
    company: {},
  },
};

export const project_for_edit = {
  project: {
    project_manager: {},
    project_type: { project_templates: { markets: {} } },
    project_template: {},
    location: { market: {}, location_users: { user: {} } },
    all_locations: { market: {}, location_users: { user: {} } },
    market: {},
    project_users: { user: user_partial },
    project_contacts: { user: user_partial },
    users: user_complete,
    company: {},
    customers: {},
    custom_project_settings: {},
    teams: { users: {} },
  },
};

export const complete_project_root = {
  project: {
    builds: {
      tasks: {
        completion_criteria: {
          attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } ,
          comments: { user: { additionalFields: ['profile_image'] } },
          event_histories: {},
          form_fields: {},
        },
        reference_documents: {},
        user_task_assignments: {
          user: { additionalFields: ['profile_image'], 
            companies: {},
          },
        },
        inventory_items: {  inventory: {} },
        event_histories: { },
      },
    },
    project_manager: {},
    project_type: {},
    project_template: {},
    project_users: { user: { companies: {}, additionalFields: ['profile_image'] } },
    users: user_complete,
    location: {},
    all_locations: {},
    company: {},
    custom_project_settings: {},
  },
};

export const complete_project_root_mobile = {
  project: {
    tasks: {
      additionalFields: ['has_field_user', 'has_reviewer', 'has_approver'],
      completion_criteria: {
        attachments: { additionalFields: ['upload', 'upload_thumb', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } ,
        comments: { user: { additionalFields: ['profile_image'] } },
        event_histories: {},
        form_fields: {},
      },
      reference_documents: {},
      user_task_assignments: {
        user: { additionalFields: ['profile_image'], 
          companies: {},
        },
      },
      inventory_items: {  inventory: {} },
    },
    project_manager: {},
    project_type: {},
    project_template: {},
    project_users: { user: { companies: {}, additionalFields: ['profile_image'] } },
    users: user_complete,
    location: {},
    all_locations: {},
    company: {},
    custom_project_settings: {},
  },
};

export const complete_project_favorites = {
  project: {
    tasks: {
      additionalFields: ['has_field_user', 'has_reviewer', 'has_approver'],
      completion_criteria: {
        attachments: {},
        comments: { user: { additionalFields: ['profile_image'] } },
        form_fields: {},
      },
      reference_documents: {},
      comments: {},
      user_task_assignments: {
        user: { additionalFields: ['profile_image'] },
      },
      inventory_items: {  inventory: {} },
    },
    users: user_complete,
  },
};

export const complete_project_favorites_mobile = {
  project: {
    location: { market: {}, location_users: { user: {} } },
    tasks: {
      additionalFields: ['has_field_user', 'has_reviewer', 'has_approver'],
      completion_criteria: {
        attachments: { excludeFields: ['upload_small', 'upload_annotated'] } ,
        comments: { user: { additionalFields: ['profile_image'] } },
        form_fields: {},
      },
      reference_documents: {},
      user_task_assignments: {
        user: { additionalFields: ['profile_image'] },
      },
      inventory_items: {  inventory: {} },
    },
    users: user_complete,
  },
};

export const project_with_tasks_root = {
  project: {
    tasks: {},
    project_manager: {},
    project_type: {},
    project_template: {},
    project_users: { user: { companies: {}, additionalFields: ['profile_image'] } },
    users: user_complete,
    location: { market: {}, location_users: { user: {} } },
    all_locations: { market: {}, location_users: { user: {} } },
    company: {},
    custom_project_settings: {},
  },
};

export const mobile_project_root = {
  project: {
    project_manager: {},
    project_type: {},
    project_template: {},
    project_users: { user: { companies: {}, additionalFields: ['profile_image'] } },
    users: { additionalFields: ['profile_image'],  role: {}, companies: {}, company_vendor_users: { vendor_user: { additionalFields: ['profile_image'],  role: {}, companies: {} } } },
    location: { market: {}, users: user_partial, location_users: { user: { additionalFields: ['profile_image'] } } },
    all_locations: { market: {}, users: user_partial, location_users: { user: { additionalFields: ['profile_image'] } } },
    company: {},
    custom_project_settings: {},
    reference_documents: {},
    unique_documents: {},
    project_contacts: {
      user: {},
    },
  },
};

export const bulk_assign_projects = {
  project: {
    builds: {
      tasks: {
        user_task_assignments: {
          user: { additionalFields: ['profile_image'], 
            company: {
            },
            company_vendor_users: {
              company: {
              },
            },
            role: {
            },
          },
        },
      },
    },
    project_manager: {},
    project_users: {},
    location: { market: {} },
    all_locations: { market: {} },
    users: user_complete,
    company: {},
  },
};

export const location_project_root = {
  project: {
    project_manager: {},
    project_type: {},
    project_template: {},
    project_users: {},
    users: {},
    location: {},
    all_locations: {},
    company: {},
    closeouts: { user: {} },
    documents: { attachment: { user: {}, upload: {}, excludeFields: ['conversions', 'photo_latitude', 'photo_longitude', 'photo_taken_at', 'location_source'] } },
  },
};

export const project_report_root = {
  project: {
    project_manager: {},
    project_type: {},
    project_template: {},
    location: {},
    all_locations: {},
  },
};

export const project_card = {
  project: {

  },
};

export const attributes_project_root = {
  project: {},
};

export default class ProjectsDAO extends DAO {

  /*************************************************************
   *
   *  Initialization
   *
   *************************************************************/

  constructor(store) {
    super(store, 'project');
    this.OfflineQueue = OfflineQueue;
    this.unsetProject = this.unsetProject.bind(this);
    this.clearProjects = this.clearProjects.bind(this);
    this.mapToReturn = this.mapToReturn.bind(this);
    // this.checkBuilds = this.checkBuilds.bind(this)
    this.overrideMapToReturn = this.overrideMapToReturn.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.checkProjectCollections = this.checkProjectCollections.bind(this);
    this.handleOffLineFavoritesFetch = this.handleOffLineFavoritesFetch.bind(this);
  }

  unsetProject(projectId) {
    StoreItemProcessing.deleteItemInStore(this.itemType, projectId);
  }

  clearProjects() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  mapToReturn(project, options) {
    let denormalizedProject = super.mapToReturn(project, options);

    //what if we don't have builds here?
    if (denormalizedProject && denormalizedProject.builds) {
      let rootBuildWithHierarchy = denormalizedProject.builds.filter(build => {
        return build && build.ancestry && build.ancestry.split('/').length == 1;
      });
      const rootBuild = { id: denormalizedProject.root_build_id, name: denormalizedProject.name, builds: rootBuildWithHierarchy };
      denormalizedProject.root_build = rootBuild;
    }
    
    return denormalizedProject;
  }

  overrideMapToReturn(response){
    if (response.included) {
      let root_build_id = null;
      response.included = response.included.filter(include => {
        if (include.type == 'build' && include.attributes.ancestry == null) {
          root_build_id = +include.id;
          return false;
        }
        else {
          return true;
        }
      });
      if (root_build_id && response.data.relationships.builds){
        response.data.relationships.builds.data = response.data.relationships.builds.data.filter(build => {
          return +build.id != root_build_id;
        });
      }
    }
    return response;
  }

  getProject(projectId, options, noPreProcess, prefetchCallback) {
    return new Promise((resolve) => {
      return resolve(this._getItem(projectId,
        projectsService.getProject.bind(this, projectId, null, options),
        options, this.mapToReturn, !noPreProcess ? this.overrideMapToReturn : null, prefetchCallback).then(project => {
          return project;
        }));
    });
  }

  getProjectBuilds(projectId, buildOptions, projectOptions) {
    return new Promise((resolve) => {
      const project = this.findItem(projectId);
      if (project && project.builds) {
        if (this.shouldRefresh(project, { recordDescriptor: { project: { builds: {} } } })) {
          return resolve(buildsService.getBuildsByIds(project.builds, buildOptions).then(builds => {
            const ids = StoreItemProcessing.normalizeAndSyncCollectionToStore('build', builds);
            project.builds = ids;
            StoreItemProcessing.setItemInStore('project', project);
            let foundProject = this.findItem(project.id);
            return this.mapToReturn(foundProject, projectOptions);
          }));
        }
        else {
          return resolve(this.mapToReturn(project, projectOptions));
        }
      }
      else {
        return resolve(this.getProject(projectId, projectOptions));
      }
    });
  }

  async getBulkAssignProject(projectId, options, noPreProcess) {

    return await dataModel.projectsDAO.getProject(projectId, options, true);
  }

  getLocationProject(projectId, options) {

    return this._getItem(projectId,
      projectsService.getLocationProject.bind(this, projectId, null, options),
      options,
      this.mapToReturn);
  }

  /**
   * PROJECT CRUD FUNCTIONS
   */
  createProject(project, eventMetaDatum, options) {
    return projectsService.createProject(project, eventMetaDatum, options).then(response => {
      if (response.error) {
        const error = response.error.response && response.error.response.data && response.error.response.data.name ? 'Project with same name already exist' : response.error;
        dataModel.displayHTTPError('Creating a project', error, false);
        this.throwItemError('Error creating a project', response);
      }
      else {
        this.normalizeAndSyncToStore(response, options);
        const denormalized = this.mapToReturn(this.findItem(response.data.id), options);
        // dataModel.projectTypesDAO.markNeedsAttributeSync(denormalized.project_type_id)
        return denormalized;
      }
    }).catch(error => {
      throw error;
    });
  }

  updateProject(project, options) {
    return new Promise((resolve) => {

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'update', { project });
        return resolve(project); //TODO how do we feel about this?
      }
      else {
        let foundProject = this.findItem(project.id);
        project.project_type_id = project.project_type ? project.project_type.id : project.project_type_id;
        project.project_template_id = project.project_template ? project.project_template.id : project.project_template_id;
        const projectTemplate = project.project_template;
        let removeProjectTemplate = false;
        let migrateTemplate = true;
        if (project.project_type_id == -1) {
          // special case... this indicates that the project template
          // should be removed (BTW, why do we have both project type and template id in the projects table?)
          delete project.project_type_id;
          delete project.project_template_id;
          removeProjectTemplate = true;
          migrateTemplate = false;
        } else if (foundProject && projectTemplate && foundProject.project_template_id == projectTemplate.id) {
          migrateTemplate = false;
        }
      
        if (projectTemplate && migrateTemplate) {
          project.projected_start_date = null;
        }
        this.normalizeItem(project, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);
        
        return resolve(projectsService.updateProject(project).then(response => {
          if (response.error && !response.offline) {
            if (response.error.response && response.error.response.status && response.error.response.status == 409) {
              dataModel.displayHTTPError('Updating a project', 'Project with same name and id already exists', false);
            }
            else {
              dataModel.displayHTTPError('Updating a project', response.error, false);
            }
            this.markError(project);
            this.throwItemError();
          }
          else if (response.offline) {
            this.markDirty(project, true);
            this.OfflineQueue.addQueueItem(this.itemType, 'update', { project: project });
            return project;
          }
          else if (response.error) {
            dataModel.displayHTTPError('Updating a project', response.error, false);
            this.markError(project);
          }    
          else {
            this.markDirty(project, false);
            this.normalizeAndSyncToStore(response, options);
            let updatedProject = this.findItem(project.id);

            if (removeProjectTemplate) {
              projectsService.removeProjectTemplate(project).then(() => {
              });
            }
            return this.mapToReturn(this.findItem(updatedProject.id), options);
          }
        }));
      }
    });
  }

  copyProject(project, options) {
    if (dataModel.isOffline) {
      this.markDirty(project, true);
      this.OfflineQueue.addQueueItem(this.itemType, 'copy', { project });
      return Promise.resolve(project);
    }
    dataModel.inProgress = 30000;
    return projectsService.copyProject(project).then(response => {
      dataModel.inProgress = 0;
      if (response.error && !response.offline) {
        dataModel.displayHTTPError('Copying a project', response.error, false);
        this.markError(project);
        this.throwItemError();
      }
      else if (response.offline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem(this.itemType, 'copy', { project });
        return Promise.resolve(project);
      }
      else {
        this.markDirty(project, false);
        let copiedProject = this.normalizeAndSyncToStore(response, options);
        let updatedProject = this.findItem(copiedProject.id);
        return this.mapToReturn(this.findItem(updatedProject.id), options);
      }
    });
  }

  deleteProject(projectId) {
    const project = this.findItem(projectId);
    if (dataModel.isOffline) {
      this.OfflineQueue.addQueueItem('project', 'delete', { projectId });
      return Promise.resolve('offline');
    }
    this.markDeleted(project);
    return projectsService.deleteProject(projectId).then(response => {
      if (response.error && !response.offline) {
        dataModel.displayHTTPError('Deleting a project', response.error);
        return false;
      }
      else if (response.offline) {
        this.OfflineQueue.addQueueItem('project', 'delete', { projectId });
        return false;
      }
      else {
        dataModel.displayInfoErrorMessage('The project was successfully deleted.', 4000, 1);
        return true;
      }
    });
  }

  archiveProject(projectId, options) {
    // TODO: ProjectsCollection & actionCable considerations
    const project = this.findItem(projectId);
    if (dataModel.isOffline) {
      this.markDirty(project, true);
      this.OfflineQueue.addQueueItem(this.itemType, 'archive', { projectId });
      return Promise.resolve(project);
    }
    else {
      this.markDeleted(project);
      return projectsService.archiveProject(projectId).then(response => {
        if (response.error && !response.offline) {
          dataModel.displayHTTPError('Archiving a project', response.error, false);
          this.markError(project);
          this.throwItemError();
        }
        else if (response.offline) {
          this.markDirty(project, true);
          this.OfflineQueue.addQueueItem(this.itemType, 'archive', { projectId });
          return Promise.resolve(project);
        }
        else {
          this.markDirty(project, false);
          dataModel.displayInfoErrorMessage('The project was successfully archived.', 4000, 1);
          return true;
        }
      });
    }
  }

  unarchiveProject(projectId, options) {
    const project = this.findItem(projectId);
    if (dataModel.isOffline) {
      this.markDirty(project, true);
      this.OfflineQueue.addQueueItem(this.itemType, 'unarchive', { projectId });
      return Promise.resolve(project);
    }
    else {
      this.markDeleted(project);
      return projectsService.unarchiveProject(projectId).then(response => {
        if (response.error && !response.offline) {
          dataModel.displayHTTPError('Unarchiving a project', response.error, false);
          this.markError(project);
          this.throwItemError();
        }
        else if (response.offline) {
          this.markDirty(project, true);
          this.OfflineQueue.addQueueItem(this.itemType, 'unarchive', { projectId });
          return Promise.resolve(project);
        }
        else {
          this.markDirty(project, false);
          dataModel.displayInfoErrorMessage('The project was successfully unarchived.', 4000, 1);
          return true;
        }
      });
    }
  }

  handleOffLineFavoritesFetch(options) {

    return this.getOfflineProjects(options);

  }

  /** FAVORITE FUNCTIONS */
  async fetchFavorites(user_id) {
    if (!dataModel.isOffline) {
      const recordDescriptor = !!window.cordova ? complete_project_favorites_mobile : complete_project_favorites;
      return projectsService.getFavorites(user_id, { recordDescriptor }).then((response) => {
        if (response.error || response.offline) {
          
        }
        else {
          let projects = this.normalizeAndSyncCollectionToStore(response, { recordDescriptor });

          // project will be in result.data array
          // build, task, location, market, project_manager, project_user, user, role in result.included array
          // shallow completion_criterion will be in each task above

          if (projects) {
            for (let project of projects) {
              if (typeof project == 'number') {
                project = this.findItem(project);
              }
              project = this.denormalizeItem(project, complete_project_root_mobile);
              project.is_favorite = true;
              // only user tasks that are specific to the current user
              const tasks = !project.tasks ? [] : project.tasks.filter(task => {
                if (task.user_task_assignments && task.user_task_assignments.length > 0) {
                  const myTask = task.user_task_assignments.filter(uta => {
                    if (uta) {
                      if (uta.assignment_type == 'field_user') {
                        task.has_field_user = true;
                      }
                      if (uta.assignment_type == 'reviewer') {
                        task.has_reviewer = true;
                      }
                      if (uta.assignment_type == 'approver') {
                        task.has_approver = true;
                      }
                      return uta.user_id == user_id;
                    }
                    else {
                      return false;
                    }
                  });
                  return myTask.length > 0;
                }
                else {
                  return false;
                }
              });
              project.tasks = tasks;
              this.markSynced(project);
              this.normalizeItem(project, { store: true });
            }
          }
        }
      })
        .catch(error => {
          console.log(error);
        });
    }
  }

  setOfflineProject(projectId, offlineValue, eventMetadatum, options) {

    return new Promise((resolve) => {
      let project = this.findItem(projectId);
      if(!eventMetadatum) {
        eventMetadatum = Metadata.generateMetadatum();
      }
      if (project) {
        project.is_offline_project = offlineValue;
        this.normalizeItem(project, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);

        if(dataModel.isOffline) {
          return resolve(this.handleOfflineOfflineProject(project, offlineValue, eventMetadatum));
        } else {
          if(offlineValue){
            if(!options || !options.recordDescriptor){
              options = options ? Object.assign({}, options, { recordDescriptor: complete_project_root_mobile }) : { recordDescriptor: complete_project_root_mobile };
            }
            return resolve(projectsService.createOfflineProject(project, eventMetadatum, options)
              .then(results => {
                return this.handleOfflined(results, project, offlineValue, eventMetadatum, 'Offlining a project', options);
              })
              .catch(error => {
                console.log(error);
              })
            );
          } else {
            return resolve(projectsService.deleteOfflineProject(projectId, eventMetadatum)
              .then(results => {
                return this.handleOfflined(results, project, offlineValue, eventMetadatum, 'UnOfflining a project', options);
              })
              .catch(error => {
                console.log(error);
              }) 
            );
          }
        }
      } else {
        return Promise.reject('Project not found!');
      }
    });
  }

  setFavoriteProject(projectId, favoriteValue, eventMetadatum, options) {
    return new Promise((resolve, reject) => {
      let project = this.findItem(projectId);
      if (!eventMetadatum) {
        eventMetadatum = Metadata.generateMetadatum();
      }

      if (project) {
        project.is_favorite = favoriteValue;
        this.normalizeItem(project, { store: true });
        dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);

        if (dataModel.isOffline) {
          return resolve(this.handleOfflineFavorite(project, favoriteValue, eventMetadatum));
        }
        else {
          if (favoriteValue) {
            if ((!options || !options.recordDescriptor)) {// && dataModel.mobileBridge.isMobile){
              options = options ? Object.assign({}, options, { recordDescriptor: complete_project_root_mobile }) : { recordDescriptor: complete_project_root_mobile };
            }
            return resolve(projectsService.createFavorite(project, eventMetadatum, options).then(results => {
              return this.handleFavorited(results, project, favoriteValue, eventMetadatum, 'Favoriting a project', options);
            })
              .catch(error => {
                console.log(error);
                return this.getStoredProjectWithFavorite(project.id, true, options);
              }));
          }
          else {
            return resolve(projectsService.deleteFavorite(projectId, eventMetadatum).then((results) => {
              return this.handleFavorited(results, project, favoriteValue, eventMetadatum, 'Unfavoriting a project', options);
            })
              .catch(error => {
                console.log(error);
                return this.getStoredProjectWithFavorite(projectId, false, options);
              }));
          }
        }
      }
      else {
        reject('Project not found!');
      }
    });
  }

  getStoredProjectWithFavorite(projectId, favoriteValue, options) {
    const stored = this.findItem(projectId);
    if (stored) stored.is_favorite = favoriteValue;
    return stored ? this.mapToReturn(stored, options) : undefined;
  }

  handleFavorited(results, project, favoriteValue, eventMetadatum, errorMessage, options) {
    if (results.error && !results.offline) {
      dataModel.displayHTTPError(errorMessage, results.error, false);
    }
    else if (results.offline) {
      return this.handleOfflineFavorite(project, favoriteValue, eventMetadatum);
    }
    else {
      return this.handleOnlineFavorite(project, results, favoriteValue, eventMetadatum, options);
    }
  }

  handleOfflined(results, project, offlineValue, eventMetadatum, errorMessage, options) {
    console.log('when a error',results,results.offline);
    if (results.error && !results.offline) {
      localStorage.setItem('is_offline_project',results.offline); //save state (is offline project)
      dataModel.displayHTTPError(errorMessage, results.error, false);
    }
    else if (results.offline) {
      return this.handleOfflineOfflineProject(project, offlineValue, eventMetadatum);
    }
    else {
      return this.handleOnlineOfflineProject(project, results, offlineValue, eventMetadatum, options);
    }
  }

  handleOnlineFavorite(project, results, favoriteValue, eventMetadatum, options) {
    this.markDirty(project, false);
    this.normalizeAndSyncToStore(results, options);
    let projectToReturn = this.mapToReturn(this.findItem(project.id), options);
    if (!projectToReturn) {
      projectToReturn = project;
    }
    projectToReturn.is_favorite = favoriteValue;

    if (dataModel.mobileBridge.isMobile && favoriteValue) {
      // only user tasks that are specific to the current user
      const tasks = (projectToReturn.tasks || []).filter(task => {
        if (task.user_task_assignments && task.user_task_assignments.length > 0) {
          const myTask = task.user_task_assignments.filter(uta => {
            return uta.user_id == dataModel.usersDAO.currentUser.id;
          });
          return myTask.length > 0;
        }
        else {
          return false;
        }
      });
      projectToReturn.tasks = tasks;
      this.normalizeItem(projectToReturn, { store: true, recordDescriptor: options ? options.recordDescriptor : null });
    }
    return projectToReturn;
  }

  handleOnlineOfflineProject(project, results, offlineValue, eventMetadatum, options) {
    this.markDirty(project, false);    
    this.normalizeAndSyncToStore(results, options);
    project = this.mapToReturn(this.findItem(project.id), options);

    if (dataModel.mobileBridge.isMobile && offlineValue) {
      project.is_offline_project= true;
      const tasks = project.tasks.filter(task => {
        if (task.user_task_assignments && task.user_task_assignments.length > 0) {
          const myTask = task.user_task_assignments.filter(uta => {
            return uta.user_id == dataModel.usersDAO.currentUser.id;
          });
          return myTask.length > 0;
        }
        else {
          return false;
        }
      });
      project.tasks = tasks;
      this.normalizeItem(project, { store: true, recordDescriptor: options ? options.recordDescriptor : null });
    }
    return project;
  }

  handleOfflineFavorite(project, favoriteValue, eventMetadatum) {
    this.markDirty(project, true);
    this.OfflineQueue.addQueueItem('project', 'favorite',
      {
        project: project,
        favoriteValue,
        eventMetadatum,
      });
    return this.mapToReturn(this.findItem(project.id));
  }

  handleOfflineOfflineProject(project, offlineValue, eventMetadatum) {
    this.markDirty(project, true);
    this.OfflineQueue.addQueueItem('project', 'offline_project',
      {
        project: project,
        offlineValue,
        eventMetadatum,
      });
    return this.mapToReturn(this.findItem(project.id));
  }

  /** PROJECT USER FUNCTIONS */
  async setProjectManager(project, user, options) {
    project.project_manager_id = user.id;
    return this.updateProject(project, options);
  }

  async removeProjectManager(project, options) {
    project.project_manager_id = null;
    return this.updateProject(project, options);
  }

  addOrRemoveNotifyUser(project, user, remove = false, options) {
    return new Promise((resolve) => {
      if (remove) {
        // removing user
        const userIndex = project.project_users.findIndex(assignedUser => assignedUser.user_id == user.id);
        if (userIndex >= 0) {
          project.project_users.splice(userIndex, 1);
        }
      }
      else {
        // adding user
        const userAlreadyAdded = project.project_users.find(assignedUser => assignedUser.user_id == user.id);
        if (!userAlreadyAdded) {
          project.project_users.push({
            assignment_type: 'notify',
            user_id: user.id,
            user,
          });
        }
      }

      this.normalizeItem(project, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'notify_user', { project, user, remove });
        return resolve(project);
      }
      else {
        const serviceCall = remove ? projectsService.deleteNotify : projectsService.createNotify;
        return resolve(serviceCall(project, user).then(response => {
          if (response.error && !response.offline) {
            dataModel.displayHTTPError('Updating a project', response.error, false);
          }
          else if (response.offline) {
            this.markDirty(project, true);
            this.OfflineQueue.addQueueItem('project', 'notify_user', { project, user, remove });
            return project;
          }
          else if (response.error) {
            return this.mapToReturn(this.findItem(project.id), options);
          }
          else {
            this.markDirty(project, false);
            const storeItem = this.normalizeAndSyncToStore(response, options);
            return (this.mapToReturn(storeItem, options));
          }
        }));
      }
    });
  }

  addUserToProject(user, projectObject, options) {
    const userId=typeof user == 'object'?user.id:user;
    return new Promise((resolve) => {
      const project = _.cloneDeep(projectObject);
      if (!project.users) {
        project.users = [];
      }

      if (!project.users.find(u => { return u.id == userId; })) {
        project.users.push(user);
      }

      this.normalizeItem(project, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'add_user', { userId: userId, project });
        return resolve(project);
      }
      else {
        return resolve(projectsService.addUserToProject(userId, project).then(response => {
          if (response.error && !response.offline) {
            dataModel.displayHTTPError('Updating a project', response.error, false);
          }
          else if (response.offline) {
            this.markDirty(project, true);
            this.OfflineQueue.addQueueItem('project', 'add_user', { userId: userId, project });
            return project;
          }
          else {
            this.markDirty(project, false);
            const storeItem = this.normalizeAndSyncToStore(response, options);
            return (this.mapToReturn(storeItem, options));
          }
        }));
      }
    });
  }

  removeUserFromProject(user, projectObject, options) {
    const userId=typeof user == 'object'?user.id:user;
    return new Promise((resolve) => {
      const project = _.cloneDeep(projectObject);

      if (!project.users) {
        return resolve(project);        
      }
      project.users = project.users.filter(u => {
        return u.id != userId;
      });

      this.normalizeItem(project, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'remove_user', { userId: userId, project });
        return Promise.resolve(project);
      }
      else {
        return resolve(projectsService.removeUserFromProject(userId, project).then(response => {
          if (response.error && !response.offline) {
            dataModel.displayHTTPError('Updating a project', response.error, false);
          }
          else if (response.offline) {
            this.markDirty(project, true);
            this.OfflineQueue.addQueueItem('project', 'remove_user', { userId: userId, project });
            return project;
          }
          else {
            this.markDirty(project, false);
            const storeItem = this.normalizeAndSyncToStore(response, options);
            return (this.mapToReturn(storeItem, options));
          }
        }));
      }
    });
  }

  replaceProjectMember(project, oldUser, newUser, options) {
    return new Promise((resolve) => {
      if (!project.users) {
        project.users = [];
      }
      let userIndex = -1;
      if (project.users.find((user, index) => {
        userIndex = index;
        return oldUser.id == user.id;
      })) {
        project.users[userIndex] = newUser;
      }
      else {
        project.users.push(newUser);
      }

      this.normalizeItem(project, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'replace_user', { project, oldUser, newUser });
        return Promise.resolve(project);
      }
      else {
        return resolve(projectsService.replaceMember(project, oldUser, newUser).then(response => {
          if (response.error && !response.offline) {
            // TODO: error handling
          }
          else if (response.offline) {
            this.OfflineQueue.addQueueItem('project', 'replace_user', { project, oldUser, newUser });
            return project;
          }
          else {
            this.markDirty(project, false);
            return (project);
          }
        }));
      }
    });
  }

  get creationIndex() {
    if (!this._creationIndex) {
      this._creationIndex = 0;
    }
    this._creationIndex--;
    return this._creationIndex;
  }

  addUniqueDocument(project, documentId, documentObject, options) {
    return new Promise((resolve) => {
      if (!documentId && (!documentObject.name || !documentObject.attachment)) {
        throw new Error('Either document ID, or name+attachment are required');
      }

      let tempDO = { attachment_content_type: documentObject.attachment.type, name: documentObject.name, id: this.creationIndex, created_at: new Date().toJSON() };
      if (!project.unique_documents) {
        project.unique_documents = [];
      }
      project.unique_documents.push(tempDO);
      this.normalizeItem(project, { store: true });
      dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);  

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'add_document', { project, documentId, documentObject });
        return resolve(project);
      }
      return resolve(projectsService.addUniqueDocument(project.id, documentId, documentObject, options).then(response => {
        if (response.error && !response.offline) {
          // TODO: error handling
        }
        else if (response.offline) {
          this.markDirty(project, true);
          this.OfflineQueue.addQueueItem('project', 'add_document', { project, documentId });
          return resolve(project);
        }
        else {
          this.markDirty(project, false);
          
          this.normalizeAndSyncToStore(response, options);
          return this.mapToReturn(this.findItem(project.id), options);
        }
      }));
    });
  }

  removeUniqueDocument(project, documentId, options) {
    return new Promise((resolve) => {
      project.unique_documents = project.unique_documents.filter(doc => {
        return doc.id != documentId;
      });
      this.normalizeItem(project, { store: true });

      dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);  

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'remove_document', { project, documentId });
        return resolve(project);
      }
      return resolve(projectsService.removeUniqueDocument(project.id, documentId).then(response => {
        if (response.error && !response.offline) {
          // TODO: error handling
        }
        else if (response.offline) {
          this.markDirty(project, true);
          this.OfflineQueue.addQueueItem('project', 'remove_document', { project, documentId });
          return project;
        }
        else {
          this.normalizeAndSyncToStore(response, options);
          return this.mapToReturn(this.findItem(project.id), options);
        }
      }));
    });
  }

  removeReferenceDocument(project, documentId, options) {
    return new Promise((resolve) => {
      project.unique_documents = project.reference_documents.filter(doc => {
        return doc.id != documentId;
      });
      this.normalizeItem(project, { store: true });

      dataModel.actionCableConnector.internalUpdate({ type: 'updateProject', project_id: project.id }, project.id);  

      if (dataModel.isOffline) {
        this.markDirty(project, true);
        this.OfflineQueue.addQueueItem('project', 'remove_ref_document', { project, documentId });
        return resolve(project);
      }
      return resolve(projectsService.removeReferenceDocument(project.id, documentId).then(response => {
        if (response.error && !response.offline) {
          dataModel.displayHTTPError('Deleting a ref document', response.error, false);
          this.throwItemError();
        }
        else if (response.offline) {
          this.markDirty(project, true);
          this.OfflineQueue.addQueueItem('project', 'remove_ref_document', { project, documentId });
          return project;
        }
        else {
          this.normalizeAndSyncToStore(response, options);
          return this.mapToReturn(this.findItem(project.id), options);
        }
      }));
    });
  }

  createProjectContact(projectContact) {
    return projectsService.createProjectContact(projectContact).then(response => {
      const projectContact = this.normalizeAndSyncToStore(response);
      const options = {
        recordDescriptor: {
          project_contact: {
            user: {},
          },
        } };
      return this.mapToReturn(projectContact, options);
    });
  }

  updateProjectContact(projectContact) {
    return projectsService.updateProjectContact(projectContact).then(response => {
      const projectContact = this.normalizeAndSyncToStore(response);
      const options = {
        recordDescriptor: {
          project_contact: {
            user: {},
          },
        } };
      return this.mapToReturn(projectContact, options);
    });
  }

  deleteProjectContact(userId, locationId) {
    return projectsService.deleteProjectContact(locationId, userId).then(response => {
      
    });
  }

  countUserAssignments(project, userId) {
    return projectsService.countUserAssignments(project.id, userId).then(response => {
      return response;
    });
  }

  /** Util Functions */
  completeOfflineUpdate(queueItem) {
    switch(queueItem.operationKey) {
    case 'create':
      return this.createProject(queueItem.itemInfo.project);
    case 'update':
      return this.updateProject(queueItem.itemInfo.project);
    case 'delete':
      return this.deleteProject(queueItem.itemInfo.projectId);
    case 'favorite':
      return this.setFavoriteProject(queueItem.itemInfo.project.id, queueItem.itemInfo.favoriteValue);
    case 'offline_project':
      return this.setOfflineProject(queueItem.itemInfo.project.id, queueItem.itemInfo.offlineValue);
    case 'add_user':
      return this.addUserToProject(queueItem.itemInfo.userId, queueItem.itemInfo.project);
    case 'remove_user':
      return this.removeUserFromProject(queueItem.itemInfo.userId, queueItem.itemInfo.project);
    case 'replace_user':
      return this.replaceProjectMember(queueItem.itemInfo.project, queueItem.itemInfo.oldUser, queueItem.itemInfo.newUser);
    case 'notify_user':
      return this.addOrRemoveNotifyUser(queueItem.itemInfo.project, queueItem.itemInfo.user, queueItem.itemInfo.remove);
    case 'remove_document':
      return this.removeUniqueDocument(queueItem.itemInfo.project, queueItem.itemInfo.documentId);
    case 'remove_ref_document':
      return this.removeReferenceDocument(queueItem.itemInfo.project, queueItem.itemInfo.documentId);
    case 'add_document':
      return this.addUniqueDocument(queueItem.itemInfo.project, queueItem.itemInfo.documentId, queueItem.itemInfo.documentObject);
    case 'copy':
      return this.copyProject(queueItem.itemInfo.project);
    case 'archive':
      return this.archiveProject(queueItem.itemInfo.projectId);
    case 'unarchive':
      return this.unarchiveProject(queueItem.itemInfo.projectId);
    default:
      break;
    }
  }

  checkProjectCollections(project_id) {
    let collectionIds = dataModel.collectionsDAO.getCollectionsByType(ReduxConstants.PROJECT);
    for (let collectionId of collectionIds) {
      let collection = dataModel.collectionsDAO.findCollection(collectionId);

      if (collection && !collection.ids.find(id => {return id == project_id;})){
        collection._recordState = RecordStates.NEEDS_SYNC;
        dataModel.collectionsDAO.setCollection(collectionId, collection, ReduxConstants.PROJECT);
      }
    }
  }

  checkLocationCollections(location_id) {
    let collectionIds = dataModel.collectionsDAO.getCollectionsByType(ReduxConstants.LOCATION);
    for (let collectionId of collectionIds) {
      let collection = dataModel.collectionsDAO.findCollection(collectionId);

      if (collection && !collection.ids.find(id => {return id == location_id;})){
        collection._recordState = RecordStates.NEEDS_SYNC;
        dataModel.collectionsDAO.setCollection(collectionId, collection, ReduxConstants.LOCATION);
      }
    }
  }

  handleActionCableAndGetRequest(acData, mark = true) {
    let project = this.findItem(acData.project_id);
    if (mark) {
      if (project) {
        if (acData.is_attribute_update) {
          this.markNeedsAttributeSync(project);
        }
        else {
          this.markNeedsSync(project);
        }
      }
    }
    this.checkProjectCollections(acData.project_id);
    if (acData.is_attribute_update) {
      // TODO
      // options.filter = SOME_ATTRIBUTE_FILTER
    }
    switch (acData.type) {
    case 'newProject':
    case 'updateProject':
    case 'updateProjectMemberAssignments':
      return this.getProject.bind(this);
    case 'deleteProject':
    case 'deleteProjectForLocation':
      this.unsetProject(acData.project_id);
      return project;
    default:
    }

  }

  getOfflineProjects(options) {
    let projects = [];
    for (let key in this.stateTree.new_projects) {
      if (key && this.stateTree.new_projects[key]) {
        const denormDescriptor = options.recordDescriptor && options.recordDescriptor.project ? options.recordDescriptor.project : options.recordDescriptor;
        const project = this.denormalizeItem(this.stateTree.new_projects[key], denormDescriptor);
        if (project && project.is_favorite) {
       // if (project && project.is_offline_project) {
          projects.push(project);
        }
      }
    }
    return projects;
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_projects, options.toIgnore.projects, this.unsetProject, this.clearProjects, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/ProjectsDAO.js